<template>
<div> 
  <b-container>
    <div id="globalAnalytics">
      <b-row align-v="center" >
        <div class="col-md-5 d-flex ">
          <span class="h3 mr-1">Analytics Overview</span>
          <div>
            <b-button variant="mswarning " @click="initDate()" >&#x21BA;</b-button>
          </div>
        </div>
      </b-row>
      <!--<div class="col-md-4 text-md-right">
              <div>
                  <b-dropdown id="dropdown-1" v-bind:text="activeAction" variant="light">
                  <b-dropdown-item v-bind:class="{ active : isActive===1}" @click="changeIsActive(action1)">{{action1}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===2}" @click="changeIsActive(action2)">{{action2}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===3}" @click="changeIsActive(action3)">{{action3}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===4}" @click="changeIsActive(action4)">{{action4}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===5}" @click="changeIsActive(action5)">{{action5}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===6}" @click="changeIsActive(action6)">{{action6}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===7}" @click="changeIsActive(action7)">{{action7}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===8}" @click="changeIsActive(action8)">{{action8}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===9}" @click="changeIsActive(action9)">{{action9}}</b-dropdown-item>
                  <b-dropdown-item v-bind:class="{ active : isActive===10}" @click="changeIsActive(action10)">{{action10}}</b-dropdown-item>
                  </b-dropdown>
              </div>
        </div>-->
    <b-row>
       <div class="col-md-5 d-flex " ></div>
      <div class="col-md-1 text-center d-flex ">
        From :
      </div>
      <div class="col-md-3 text-md-right ">
        <div>
              <b-form-input :id="`type-date`" :type="'date'" v-model="dateFrom" ></b-form-input>
        </div>
      </div>
      <div class="col-md-3 text-md-right ">
        <div>
              <b-form-input :id="`type-time`" :type="'time'" v-model="timeFrom"></b-form-input>
        </div>
      </div>

      <div class="col-md-5 ">
      </div>
      <div class="col-md-1 text-center d-flex " align-self="center">
        To :
      </div>
      <div class="col-md-3 text-md-right ">
        <div>
              <b-form-input :id="`type-date`" :type="'date'" v-model="dateTo"></b-form-input>
        </div>
      </div>
      <div class="col-md-3 text-md-right ">
        <div>
              <b-form-input :id="`type-time`" :type="'time'" v-model="timeTo"></b-form-input>
        </div>
      </div>

      <div class="col-md-9 mb-5">
      </div>
      <div class="col-md-3 mb-5 text-md-right">
        <b-button variant="primary"  @click="refreshDate()" >OK</b-button>
      </div>

      <div class="col-md-12">
      <b-table striped hover :items="getItems" ></b-table>
      </div>
      <br/>
      <br/>
      <div class="col-md-4"></div>
      <!--<b-button class="col-md-4" variant="msstreamblue" @click="moreAnalytics()">View More...</b-button>-->
    </b-row>
    </div>
    <!--<div>
       <b-row align-v="center" >
          <div class="col-md-5 d-flex " >
            <span class="h3 mr-1">Selected Videos Analytics </span>
            <b-button variant="msstreamblue " style="margin-right: 5px;" @click="showSelectedAnalytics = !showSelectedAnalytics" >+</b-button>
            <b-button variant="mswarning " @click="initSelectDate()" >&#x21BA;</b-button>
          </div>
        </b-row>

        <b-row v-if="showSelectedAnalytics">
          <div class="col-md-5 d-flex " > </div>
          <div class="col-md-1 text-center d-flex ">
            From :
          </div>
          <div class="col-md-3 text-md-right ">
            <div>
                  <b-form-input :id="`type-date`" :type="'date'" v-model="dateFromSelect" ></b-form-input>
            </div>
          </div>
          <div class="col-md-3 text-md-right ">
            <div>
                  <b-form-input :id="`type-time`" :type="'time'" v-model="timeFromSelect"></b-form-input>
            </div>
          </div>

          <div class="col-md-5 ">
          </div>
          <div class="col-md-1 text-center d-flex " align-self="center">
            To :
          </div>
          <div class="col-md-3 text-md-right ">
            <div>
                  <b-form-input :id="`type-date`" :type="'date'" v-model="dateToSelect"></b-form-input>
            </div>
          </div>
          <div class="col-md-3 text-md-right ">
            <div>
                  <b-form-input :id="`type-time`" :type="'time'" v-model="timeToSelect"></b-form-input>
            </div>
          </div>

          <div class="col-md-9 mb-5">
          </div>
          <div class="col-md-3 mb-5 text-md-right">
            <b-button variant="primary"  @click="refreshDateSelect()" >OK</b-button>
          </div>

          <div class="col-md-12">
          <b-table striped hover :items="getSelectItems" ></b-table>
          </div>
          <div class="col-md-4"></div>
          <b-button class="col-md-4" variant="msstreamblue" @click="selectedAnalytics()">View more on selected videos...</b-button>
          
      </b-row>
    </div>-->
  </b-container>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';

import AnalyticsService from "@/services/analytics.service";
import VideoService from "@/services/video.service";
import AuthorizationKeyService from "@/services/authorizationKey.service";
var videoService = new VideoService();
var authorizationKeyService = new AuthorizationKeyService();
var analyticsService = new AnalyticsService();
export default {
  name: 'AnalyticsPage',
  data: function() {
    return {
      // Item  global analytics :
      items: [
          { Metric:"Total amount of data delivered:", Value:this.totDataDelivered+"Mb" },
          { Metric:"Total number of views:" , Value:this.totNbVues },
          { Metric:"Hours of views:", Value:this.totHoursView+"h"+this.minuteView+"min" },
          { Metric:"Mean viewing time per user:", Value:this.averageViewTime+"min" },
          { Metric:"Total number of videos:", Value:this.totalNumberOfVideos },
          { Metric:"Total number of authorization key:", Value: this.totalNumberOfAuthorizationKeys },
        ],

      //TIME 
      dateFrom:null,
      timeFrom:null,
      dateTo:null,
      timeTo:null,

      //GLOBAL ANALYTICS
      totNbVues:0,
      totDataDelivered:0,
      totHoursView:0,
      minuteView:0,
      averageViewTime:0,

      //OTHER GLOBAL ANALYTICS
      totalNumberOfVideos: 0,
      totalNumberOfAuthorizationKeys: 0,


      //TIME SELECTED VIDEO
      dateFromSelect:null,
      timeFromSelect:null,
      dateToSelect:null,
      timeToSelect:null,
      itemsSelect: [
          { Metric:"Total amount of data delivered for selected videos:", Value:this.totDataDelivered+"Mb" },
          { Metric:"Total number of views for selected videos:" , Value:this.totNbVues },
          { Metric:"Hours of views for selected videos:", Value:this.totHoursView+"h"+this.minuteView+"min" },
          { Metric:"Mean viewing time per user for selected videos:", Value:this.averageViewTime+"min" },
          { Metric:"Total number of videos selected:", Value:this.totalNumberOfVideos },
          { Metric:"Total number of authorization key for selected videos:", Value:15 },
        ],
      //Analytics Selected video
      dataDeliveredSelected:0,
      nbVuesSelected:0,
      hoursViewSelected:0,
      minutesViewSelestec:0,
      meanTimeSelected:0
    };
  },
  computed: {
    getItems() {
      this.items=[
          { Metric:"Total amount of data delivered:", Value:Math.round((this.totDataDelivered/1000)*100)/100+" GB" },
          { Metric:"Total number of views:" , Value:this.totNbVues },
          { Metric:"Hours of views:", Value:this.totHoursView+"h "+this.minuteView+"min" },
          { Metric:"Mean viewing time per user:", Value:this.averageViewTime+" min" },
          { Metric:"Total number of videos:", Value:this.totalNumberOfVideos},
          { Metric:"Total number of authorization keys:", Value:this.totalNumberOfAuthorizationKeys },
          ]
      return this.items
    },
    getSelectItems(){
      this.itemsSelect=
          [
          { Metric:"Total amount of data delivered for selected videos:", Value:this.dataDeliveredSelected+" GB" },
          { Metric:"Total number of views for selected videos:" , Value:this.nbVuesSelected },
          { Metric:"Hours of views for selected videos:", Value:this.hoursViewSelected+"h "+this.minutesViewSelestec+"min" },
          { Metric:"Mean viewing time per user for selected videos:", Value:this.meanTimeSelected+" min" },
          { Metric:"Total number of videos selected:", Value:this.numberOfVideos },
          { Metric:"Total number of authorization key for selected videos:", Value:this.selectedAuthorizationKeys.length },
          ]
      return this.itemsSelect
    }
  },
  mounted() {
    this.initDate();
    this.getNumberMetrics();
  },
  methods: {
    moreAnalytics(){
      this.$router.push('/globalanalytics/'); 
    },
    getNumberMetrics() {
        authorizationKeyService.getAuthorizationKeys(this.$auth.token(), {pagesize:0}).then((keys) => {
          this.totalNumberOfAuthorizationKeys=keys._size;
        })
        videoService.getVideosPageForClient(this.$auth.token(),{pagesize: 0}).then(videos => {
          this.totalNumberOfVideos=videos._size
        })
    },
    initDate(){
      let dateT=new Date()
      let dateF=new Date(dateT.getFullYear(),dateT.getMonth(),1,0,0,1)
      let monthF=dateF.getMonth()+1
      let dayF=dateF.getDate()
      if (monthF<10){
        this.dateFrom=dateF.getFullYear()+'-0'+monthF
      }
      else{
        this.dateFrom=dateF.getFullYear()+'-'+monthF
      }
      if (dayF<10){
        this.dateFrom+='-0'+dayF
      }
      else {
        this.dateFrom+='-'+dayF
      }
      let monthT=dateT.getMonth()+1
      let dayT=dateT.getDate()
      if (monthT<10){
        this.dateTo=dateT.getFullYear()+'-0'+monthT
      }
      else{
        this.dateTo=dateT.getFullYear()+'-'+monthT
      }
      if (dayT<10){
        this.dateTo+='-0'+dayT
      }
      else {
        this.dateTo+='-'+dayT
      }

      let hourF=dateF.getHours()
      let minuteF=dateF.getMinutes()
      if(hourF<10){
        this.timeFrom='0'+hourF
      }
      else{
        this.timeFrom=hourF
      }
      if(minuteF<10){
        this.timeFrom+=':0'+minuteF
      }
      else{
        this.timeFrom+=':'+minuteF
      }

      let hourT=dateT.getHours()
      let minuteT=dateT.getMinutes()
      if(hourT<10){
        this.timeTo='0'+hourT
      }
      else{
        this.timeTo=hourT
      }
      if(minuteT<10){
        this.timeTo+=':0'+minuteT
      }
      else{
        this.timeTo+=':'+minuteT
      }
      let date={dateT:dateT,dateF:dateF}
      this.getGlobalAnalytics(date)
    },
    refreshDate(){
      if(this.timeFrom=="" || this.timeTo=="" || this.dateFrom=="" || this.dateTo=="" ){
        this.showModal2('invalidDateModal')
      }
      else{
        let splitDateFrom=this.dateFrom.split('-')
        let splitTimeFrom=this.timeFrom.split(':')
        let splitDateTo=this.dateTo.split('-')
        let splitTimeTo=this.timeTo.split(':')
        let dateF=new Date(splitDateFrom[0],splitDateFrom[1]-1,splitDateFrom[2], splitTimeFrom[0],splitTimeFrom[1])
        let dateT=new Date(splitDateTo[0],splitDateTo[1]-1,splitDateTo[2], splitTimeTo[0],splitTimeTo[1])
        let date={dateT:dateT,dateF:dateF}
        this.getGlobalAnalytics(date)
      }
    },

    initSelectDate(){
      let dateT=new Date()
      let dateF=new Date(dateT.getFullYear(),dateT.getMonth(),1,0,0,1)
      let monthF=dateF.getMonth()+1
      let dayF=dateF.getDate()
      if (monthF<10){
        this.dateFromSelect=dateF.getFullYear()+'-0'+monthF
      }
      else{
        this.dateFromSelect=dateF.getFullYear()+'-'+monthF
      }
      if (dayF<10){
        this.dateFromSelect+='-0'+dayF
      }
      else {
        this.dateFromSelect+='-'+dayF
      }
      let monthT=dateT.getMonth()+1
      let dayT=dateT.getDate()
      if (monthT<10){
        this.dateToSelect=dateT.getFullYear()+'-0'+monthT
      }
      else{
        this.dateToSelect=dateT.getFullYear()+'-'+monthT
      }
      if (dayT<10){
        this.dateToSelect+='-0'+dayT
      }
      else {
        this.dateToSelect+='-'+dayT
      }

      let hourF=dateF.getHours()
      let minuteF=dateF.getMinutes()
      if(hourF<10){
        this.timeFromSelect='0'+hourF
      }
      else{
        this.timeFromSelect=hourF
      }
      if(minuteF<10){
        this.timeFromSelect+=':0'+minuteF
      }
      else{
        this.timeFromSelect+=':'+minuteF
      }

      let hourT=dateT.getHours()
      let minuteT=dateT.getMinutes()
      if(hourT<10){
        this.timeToSelect='0'+hourT
      }
      else{
        this.timeToSelect=hourT
      }
      if(minuteT<10){
        this.timeToSelect+=':0'+minuteT
      }
      else{
        this.timeToSelect+=':'+minuteT
      }
      let date={dateT:dateT,dateF:dateF}
      this.getSelectAnalytics(date, this.selectedAuthorizationKeys)
    },

    refreshDateSelect(){
      if(this.timeFromSelect=="" || this.timeToSelect=="" || this.dateFromSelect=="" || this.dateToSelect=="" ){
        this.showModal2('invalidDateModal')
      }
      else{
        let splitDateFrom=this.dateFromSelect.split('-')
        let splitTimeFrom=this.timeFromSelect.split(':')
        let splitDateTo=this.dateToSelect.split('-')
        let splitTimeTo=this.timeToSelect.split(':')
        let dateF=new Date(splitDateFrom[0],splitDateFrom[1]-1,splitDateFrom[2], splitTimeFrom[0],splitTimeFrom[1])
        let dateT=new Date(splitDateTo[0],splitDateTo[1]-1,splitDateTo[2], splitTimeTo[0],splitTimeTo[1])
        let date={dateT:dateT,dateF:dateF}
        
        this.getSelectAnalytics(date, this.selectedAuthorizationKeys)
      }
    },

        /*changeIsActive(action){
        if (action==="Last Month"){
            this.isActive=1
            this.activeAction="Last Month"
        }
        else if (action==="Last Week"){
            this.isActive=2
            this.activeAction="Last Week"
        }
        else if (action==="Last Day"){
            this.isActive=3
            this.activeAction="Last Day"
        }
        else if (action==="Last Hour"){
            this.isActive=4
            this.activeAction="Last Hour"
        }
        else if (action==="Last 12 Hours"){
            this.isActive=5
            this.activeAction="Last 12 Hours"
        }
        else if (action==="This Month"){
            this.isActive=6
            this.activeAction="This Month"
        }
        else if (action==="This Week"){
            this.isActive=7
            this.activeAction="This Week"
        }
        else if (action==="This Day"){
            this.isActive=8
            this.activeAction="This Day"
        }

        else if (action==="This Hour"){
            this.isActive=9
            this.activeAction="This Hour"
        }
        else if (action==="This 12 Hours"){
            this.isActive=10
            this.activeAction="This 12 Hours"
        }

        this.getGlobalAnalytics(this.activeAction)

    },*/
    getGlobalAnalytics(date){
        analyticsService.getGlobalAnalytics(date, this.$auth.getMyUser().username).then(response=>{
          this.totNbVues=response.data.aggregations.tot_nbVues.value
          this.totDataDelivered=Math.round(response.data.aggregations.tot_data_delivered.value/1000)
          var Time=response.data.aggregations.tot_hours_view.value
          this.totHoursView=Math.floor(Time)
          var hour= Math.abs(Time);
          var decimal = hour - Math.floor(hour)
          this.minuteView=Math.floor(decimal*60)
          this.averageViewTime=Math.floor((Time*60)/this.totNbVues)

        })
    },

    getPercentRebuf(video){
      analyticsService.getPercentRebufVideo(this.$auth.token(),video).then(response=>{
        var whichResponse=response.request.responseURL.split('/')
        var whichIndex=whichResponse[4]   //A CHANGER LORS DU DEPLOIEMENT D'ELASTICSEARCH
        var sec_server=response.data.aggregations.sum_sec_server.value
        var sec_peer=response.data.aggregations.sum_sec_peer.value
        var sec_rebuf=response.data.aggregations.sum_sec_rebuff.value
        var percent_sec_rebuf=100*sec_rebuf/(sec_rebuf+sec_server+sec_peer);
      
        this.videos = this.videos.map(function(elem){
          if (elem.authorizationKey.toLowerCase()===whichIndex) {
            if (isNaN(percent_sec_rebuf)){
              elem.percent_rebuf=0
              
            }
            else{
              elem.percent_rebuf=Math.round(percent_sec_rebuf)
            }
            return elem;  
          } else {
            return elem;
          }
        })
      }).catch(error => {
          console.log(error);
      })
    },
    
    getSelectAnalytics(date, authorizationKeys){
      if (authorizationKeys.length > 0) {
        analyticsService.getSelectAnalytics(date, authorizationKeys).then(response=>{
          this.nbVuesSelected=response.data.aggregations.nbVues.value
          this.dataDeliveredSelected=(Math.round((response.data.aggregations.MB_peer.value+response.data.aggregations.MB_server.value)/1000))/1000
          var Time=(response.data.aggregations.sec_server.value+response.data.aggregations.sec_peer.value)/3600
          this.hoursViewSelected=Math.floor(Time)
          var hour= Math.abs(Time);
          var decimal = hour - Math.floor(hour)
          this.minutesViewSelestec=Math.floor(decimal*60)
          this.meanTimeSelected=Math.round((Time*60)/this.nbVuesSelected)
        })
      } else {
        this.nbVuesSelected=0
        this.dataDeliveredSelected=0
        this.hoursViewSelected=0
        this.minutesViewSelestec=0
        this.meanTimeSelected=0
      }
    },

    selectedAnalytics(){
      localStorage.setItem('authorizationKeys', JSON.stringify(this.selectedAuthorizationKeys));
      localStorage.setItem('searchParameters', JSON.stringify(this.searchParameters));
      this.$store.commit("newFocus", { pageNumber:this.currentPage, searchParameters:this.searchParameters, search: this.search});
      this.$router.push('/selectedanalytics/');
    },

    otherFunctionSelected() {
      /*authorizationKeyService.getAuthorizationKeysOfFilteredVideos(this.$auth.token(), params.filter).then((selectedAuthorizationKeys) => {
        this.selectedAuthorizationKeys = selectedAuthorizationKeys;
        this.initSelectDate()
      }).catch((error) => {
        console.log(error);
      })*/
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
